// extracted by mini-css-extract-plugin
module.exports = {"actions":"Voucher_actions__2Ga-U","actionError":"Voucher_actionError__3LozS","loading":"Voucher_loading__1HfFQ"};